import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { CountDown, Note, Page } from "../../../../helbest";
import HeaderBack from "../../../../helbest/HeaderBack/HeaderBack";
import styles from "../Auth.module.css";
import {
  _final_login_user,
  _login_user,
  _set_i_user,
  _set_channel,
  _set_pending_channel,
  _set_pending_cid,
  _set_pending_cpid,
  set_cid,
  set_cpid,
} from "../../../../store/actions/login_actions";
import { showAllErrors } from "../../../../base/utils";
import { Button } from "antd";
import { set_otp_service } from "../../../../store/actions/otp_action";
import { Trans, useTranslation } from "react-i18next";
import { ReactComponent as GMallIcon } from "../../../../assets/svg/gmall-logo.svg";
import OtpInput from "../../../../helbest/OtpInput/OtpInput";
import OtpServiceDrawer from "../../../components/OtpServiceDrawer/OtpServiceDrawer";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";
import { useMutation } from "@apollo/client";
import {
  LoginMutation,
  SendOTPMutation,
} from "../../../../graphql/none_saleor/auth/auth";
import { useMeQuery } from "../../../../saleor/api";
import { BaseChannel } from "../../../../base/env";

const SendOtp = () => {
  const dispatch = useDispatch();
  const navigate = useLangNavigate();
  const location = useLocation();
  const { availableOtp } = location.state || {};

  const [resetKey, setResetKey] = useState(0);
  const [otp, setOtp] = useState("");
  const [activeResendCode, setActiveResendCode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    country_code,
    phone_number,
    cid,
    cpid,
    urlCode,
    pendingChannel,
    pendingCid,
    pendingCpid,
    channel,
  } = useSelector((state) => state.Login);
  const { otpService } = useSelector((state) => state.Otp);
  const effectiveCid = pendingCid || cid;
  const effectiveCpid = pendingCpid || cpid;
  const { refetch: refetchMe } = useMeQuery({
    variables: {},
    skip: true,
    onError: (err) => {
      Note.error(err.message);
    },
  });

  const [sendOtpMutation] = useMutation(SendOTPMutation, {
    context: {
      clientName: "auth",
    },
  });

  const [loginMutation] = useMutation(LoginMutation, {
    context: {
      clientName: "auth",
    },
  });

  const onInput = (value) => {
    setOtp(value.join(""));
  };

  const onChange = (value) => {
    check_code(value);
  };

  const check_code = (otpCode) => {
    if (otpCode === "") {
      Note.error("please enter your security code");
      return;
    }
    if (otpCode.length === 6) {
      setLoading(true);
      loginMutation({
        variables: {
          countryCode: country_code,
          phoneNumber: phone_number,
          otp: otpCode,
          messagingService: otpService,
        },
        onCompleted: async (response) => {
          if (!response.login.errors.length) {
            dispatch(
              _login_user({
                token: response.login.token,
                refreshToken: response.login.refreshToken,
                phone_number: phone_number,
                countryCode: country_code,
                credit: 0,
                last_name: response.login.user?.lastName || "",
                first_name: response.login.user?.firstName || "",
              }),
            );
            dispatch(_final_login_user());

            const pendingStr = localStorage.getItem("pendingFastChackout");
            const hasPendingCart = localStorage.getItem("pending_cart_item");

            if (pendingStr) {
              try {
                const { data: meData } = await refetchMe();
                if (meData?.me) {
                  dispatch(
                    _set_i_user({
                      first_name: meData.me.firstName,
                      last_name: meData.me.lastName,
                      email: meData.me.email,
                      phone_number: phone_number,
                      countryCode: country_code,
                      user: { ...meData.me },
                    }),
                  );
                }
              } catch (err) {
                console.error("Failed to refetch me after login", err);
              }
              navigate("/fast-checkout");
            } else if (hasPendingCart) {
              navigate("/cart/");
            } else {
              navigate("/");
            }
          } else {
            showAllErrors(response.login.errors);
          }
        },
      }).finally(() => {
        setLoading(false);
      });
    } else {
      Note.error(t("sendOtp.errors.invalid"));
    }
  };

  const [searchParams] = useSearchParams();
  const platform = searchParams.get("platform");

  const resendOtpCode = (service) => {
    setActiveResendCode(false);
    sendOtpMutation({
      variables: {
        countryCode: country_code,
        phoneNumber: phone_number,
        messagingService: service,
        cid: effectiveCid || null,
        cpid: effectiveCpid || null,
        urlCode: urlCode || null,
        platform,
        channelSlug: pendingChannel || channel,
      },
      onCompleted: (response) => {
        if (!response.sendOtp.errors.length) {
          Note.success(t("sendOtp.resend_msg"));
        } else {
          setActiveResendCode(false);
          showAllErrors(response.sendOtp.errors);
          const hasCidError = response.sendOtp.errors.some(
            (err) => err.field === "cid",
          );
          if (hasCidError) {
            dispatch(set_cid(""));
            dispatch(set_cpid("gmall"));
            dispatch(_set_channel(BaseChannel, channel));
            dispatch(_set_pending_channel(""));
            dispatch(_set_pending_cpid(""));
            dispatch(_set_pending_cid(""));
          }
        }
      },
    });
  };

  const resetCountdown = () => {
    setResetKey((prev) => prev + 1);
  };

  const { t } = useTranslation();

  return (
    <Page
      address="/login/d/"
      headerFix
      logo
      back
      customHeader={<HeaderBack title={t("login.otp_title")} />}
      footer={
        <SubmitButton clickHandler={() => check_code(otp)} pending={loading} />
      }
      showFooter
      customPageClassName={styles.OtpPageContainer}
    >
      <div className={styles.otpSection}>
        <GMallIcon className={styles.OtpIcon} width={160} height={102} />
        <h2 className={styles.OtpTitle}>{t("sendOtp.title")}</h2>
        <p className={styles.OtpText}>
          <Trans
            i18nKey="sendOtp.enter_code"
            components={[
              <span dir="ltr">{`${country_code}${phone_number}`}</span>,
              <span>
                {availableOtp.find((item) => item.value === otpService)
                  ?.label || availableOtp[0]?.label}
              </span>,
            ]}
          />
        </p>
        <OtpInput value={otp} onInput={onInput} onChange={onChange} />
        <div className={styles.otpActions}>
          <Button
            color="default"
            variant="filled"
            disabled={!activeResendCode}
            onClick={() => setIsModalOpen(true)}
            style={{
              borderRadius: "100px",
              color: "#7F7F7F",
              height: 36,
              border: "none",
              fontWeight: !activeResendCode ? "normal" : "bold",
            }}
          >
            {t("sendOtp.re-send")}
            {!activeResendCode ? (
              <div className={styles.OtpCountDown}>
                <CountDown
                  key={resetKey}
                  className="page-login-counter"
                  time={120000}
                  onTimeUp={() => setActiveResendCode(true)}
                />
              </div>
            ) : null}
          </Button>
          <button
            className={styles.changePhoneNumber}
            onClick={() => navigate(-1)}
          >
            {t("sendOtp.change_mobile")}
          </button>
        </div>
      </div>
      <OtpServiceDrawer
        open={isModalOpen}
        setOpen={setIsModalOpen}
        onSelect={(service) => {
          dispatch(set_otp_service(service.value));
          setIsModalOpen(false);
          resetCountdown();
          resendOtpCode(service.value);
        }}
        options={availableOtp}
      />
    </Page>
  );
};

const SubmitButton = ({ clickHandler, pending }) => {
  const { t } = useTranslation();
  return (
    <div className="page-fixed-footer-container">
      <Button
        size="large"
        type="primary"
        htmlType="submit"
        onClick={clickHandler}
        loading={pending}
        style={{
          width: "100%",
          fontWeight: "bold",
        }}
      >
        {t("common.next")}
      </Button>
    </div>
  );
};

export default SendOtp;